import {
  BUTTON_COLOR,
} from "@shared/components/button/types";
import TriangleIcon from "@svg/new-design/error-trangle";
import InfoCircleIcon from "@svg/new-design/info-circle";


export const styleMap = {
  moreThan10: {
    bg: "bg-fds-info-light",
    text: "text-fds-on-info-light hover:text-fds-on-info-light-hover select:text-fds-on-info-light-select disabled:text-fds-icon-disable",
    iconColor: "text-fds-icon-brand",
    icon: InfoCircleIcon,
    buttonColor: BUTTON_COLOR.PRIMARY,
  },
  lessThan10: {
    bg: "bg-fds-warning-light",
    text: "text-fds-on-warning-light hover:text-fds-on-warning-light select:text-fds-on-warning-light disabled:text-fds-icon-disable",
    iconColor: "text-fds-icon-on-warning-light",
    icon: TriangleIcon ,
    buttonColor: BUTTON_COLOR.WARNING,
  },
  lessThan24: {
    bg: "bg-fds-danger-light",
    text: "text-fds-on-danger-light hover:text-fds-on-danger-light select:text-fds-on-danger-light disabled:text-fds-icon-disable",
    iconColor: "text-fds-icon-on-danger-light",
    icon: TriangleIcon,
    buttonColor: BUTTON_COLOR.DANGER,
  },
};
